class SiteStatementFor
    extends QueryElement<HTMLElement> {
    
    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        let from = parseInt(this.getAttr('data-from') || "0");
        let to = parseInt(this.getAttr('data-to') || "0");
        let name = this.getAttr('data-name');

        // Get inserting parent:
        let parent = this.parent();
        if (parent == null)
            throw "No parent found.";

        let propertiesToReplace = ["data-path", "data-config"];

        // Duplicate it:
        for (let x = from; x <= to; x++) {
            let toReplaceString = `[${name}]`;
            let toReplaceStringBy = `[${x}]`;

            let newContent = element.cloneNode(true) as HTMLElement;

            for (var propertyToReplace of propertiesToReplace)
            {
                let toReplaceElements = newContent.querySelectorAll(`[${propertyToReplace}*="${toReplaceString}"]`);
                for (let y = 0; y < toReplaceElements.length; y++)
                {
                    let toReplaceElement = toReplaceElements[y];
                    let newValue = (toReplaceElement.getAttribute(propertyToReplace) || "")
                        .replace(toReplaceString, toReplaceStringBy);

                    toReplaceElement.setAttribute(propertyToReplace, newValue);
                }
            }

            let innerFor = newContent.querySelectorAll("div[data-type='for']");
            for (let y = 0; y < innerFor.length; y++)
            {
                new SiteStatementFor(card, innerFor[y] as HTMLElement);
            }

            while (newContent.children.length != 0) {
                parent.insertBefore(
                    new QueryElement(newContent.children[0], false),
                    this);
            }
        }

        element.remove();
    }
}